import { WorkerMenuPrivileges } from "../privilegesProviders/WorkerMenuPrivilegesProvider";
import { type NavigationItem, type NavigationMenu, type NavigationSection } from "./types";
import { getRouteAndSelected } from "./utils";

export function getWorkerNavigationMenu(
  workerMenuPrivileges: WorkerMenuPrivileges,
  currentPath: string
): NavigationMenu {
  const items: Array<NavigationItem | NavigationSection> = [];

  if (workerMenuPrivileges.homeHealthSection) {
    if (workerMenuPrivileges.homeHealthSection.cases) {
      items.push({
        label: "Cases",
        iconType: "profile",
        ...getRouteAndSelected("agentCases", currentPath),
      });
    }
    if (workerMenuPrivileges.homeHealthSection.visits) {
      items.push({
        label: "Visit Verification",
        iconType: "badge-check",
        ...getRouteAndSelected("agentVisits", currentPath),
      });
    }
  }

  if (workerMenuPrivileges.dashboard) {
    items.push({
      label: "Calendar",
      iconType: "calendar",
      ...getRouteAndSelected("agentDashboard", currentPath),
    });
  }

  if (workerMenuPrivileges.chat) {
    const chatRouteKey = workerMenuPrivileges.chatRedesign ? "chat" : "facilityChat";
    items.push({
      label: "Chat",
      iconType: "message",
      ...getRouteAndSelected(chatRouteKey, currentPath),
    });
  }

  if (workerMenuPrivileges.dnr) {
    items.push({
      label: "DNR",
      iconType: "gps-disabled",
      ...getRouteAndSelected("agentDnr", currentPath),
    });
  }

  if (workerMenuPrivileges.payrollSection) {
    const sectionItems: NavigationItem[] = [];

    if (workerMenuPrivileges.payrollSection.payroll) {
      sectionItems.push({
        label: "Payroll",
        iconType: "money-dollar",
        ...getRouteAndSelected("agentPayroll", currentPath),
      });
    }
    if (workerMenuPrivileges.payrollSection.stripeTransfers) {
      sectionItems.push({
        label: "Stripe Transfers",
        iconType: "dollar",
        ...getRouteAndSelected("agentStripeTransfers", currentPath),
      });
    }
    if (workerMenuPrivileges.payrollSection.stripePayouts) {
      sectionItems.push({
        label: "Stripe Payouts",
        iconType: "palm-dollar",
        ...getRouteAndSelected("agentStripePayouts", currentPath),
      });
    }

    items.push({ label: "Payroll", items: sectionItems });
  }

  if (workerMenuPrivileges.clipboardScore) {
    const sectionItems: NavigationItem[] = [];

    sectionItems.push({
      label: "Clipboard Score",
      iconType: "notepad-alt",
      ...getRouteAndSelected("agentAttendance", currentPath),
    });

    items.push({ label: "Clipboard Score", items: sectionItems });
  }

  if (workerMenuPrivileges.placementSection) {
    const sectionItems: NavigationItem[] = [];

    if (workerMenuPrivileges.placementSection.candidateProfile) {
      sectionItems.push({
        label: "Candidate Profile",
        iconType: "identity-card",
        ...getRouteAndSelected("agentPlacement", currentPath),
      });
    }
    if (workerMenuPrivileges.placementSection.exclusions) {
      sectionItems.push({
        label: "Exclusions",
        iconType: "folder-person",
        ...getRouteAndSelected("agentPlacementCandidateExclusions", currentPath),
      });
    }

    items.push({ label: "Placement", items: sectionItems });
  }

  return { items };
}
